import { header } from "./modules/header";
import { marquee } from "./modules/marquee";
import { forWho } from "./modules/for-who";
import { advantages } from "./modules/advantages";
import { tabs, currency } from "./modules/tabs";
import { reviews } from "./modules/reviews";
import { faq } from "./modules/faq";
import { smoothAnchorScroll } from "./modules/smoothScroll";
import { initPreloader } from "./modules/preloader";
import { leadPopup } from "./modules/leadPopup";

window.addEventListener("load", () => {
  initPreloader();
  header();
  marquee();
  forWho();
  smoothAnchorScroll();
  advantages();
  tabs();
  currency();
  reviews();
  faq();
  leadPopup();
});
